import { Dropdown } from "primereact/dropdown";
import { useSelector } from "react-redux";
import { selectPresets } from "../store";

export function PresetDropdown({instrumentType, currentPresetID, onChange, hideInit, ...props}) {
    const presetBank = {...useSelector(selectPresets)};
    presetBank.init = {_metadata: { name: "Init", isFactory: true, instrumentType }}
    const currentPreset = presetBank[currentPresetID];
    const savedPresetsForInstrumentType = Object.fromEntries(Object.entries(presetBank)
        .filter(([_id, {_metadata: {instrumentType: pInstrumentType, isUnsaved}}]) => !isUnsaved && pInstrumentType === instrumentType)
    );

    const valueTemplate = () => {
        const { name, isUnsaved } = currentPreset._metadata;
        return <span>{name}{isUnsaved ? "*" : ""}</span>
    }

  const traduccions = { custom: 'Personalitzat', factory: 'Fàbrica' };  // todo: fer servir la manera real d'aconseguir les tradus
  return <Dropdown
    {...props}
    value={currentPresetID}
    onChange={onChange}
    options={
      Object.entries(
        Object.entries(savedPresetsForInstrumentType)
        .reduce((acc, cur) => {
          const [id, {_metadata: {name, isFactory}}] = cur;
          if (hideInit && id === "init") return acc;
          const group = isFactory ? "factory" : "custom";
          acc[group] ??= [];
          acc[group].push({value: id, name});
          return acc;
        }, {})
      )
      .sort(([groupName1, _1], [groupName2, _2]) => groupName1 < groupName2 ? -1 : 1) // així veiem custom abans de factory
      .map(([groupName, items]) => ({label: groupName, items}))
    }
    valueTemplate={valueTemplate}
    itemTemplate={(option) => <span>{option.name}</span>}
    optionGroupTemplate={(group) => <span>{traduccions[group.label]}</span>}
    optionGroupLabel="label"
    />
}